export enum ContenderDrawerTabs {
  PRIZE_POOL = 'prize-pool',
  DETAILS = 'details',
  BONUS = 'bonus',
}
